import React from 'react';
import { Box } from '@mui/material';
import { UseFormReturn, FieldErrors } from 'react-hook-form';
import { DatePickerFormControl } from '../common/form/DatePickerFormControl';
import { PeriodFormControl } from '../common/form/PeriodFormControl';
import { IntervalFormControl } from '../common/form/IntervalFormControl';
import TmFullButton from '../common/buttons/TmFullButton';
import MedicsAutocompleteFormControl from '../common/form/MedicsAutocompleteFormControl';
import { AnalyticsPeriod } from '../../models/enums/analyticsPeriod';
import { AnalyticsInterval } from '../../models/enums/analyticsInterval';
import { MedicTableViewDto } from '../../models/medics/medicTableViewDto';

export interface MedicWorkloadFilterForm {
    period: AnalyticsPeriod | '';
    date: string | null;
    interval: AnalyticsInterval | '';
    medics: MedicTableViewDto[];
}

interface MedicWorkloadFilterBarProps {
    methods: UseFormReturn<MedicWorkloadFilterForm>;
    onSubmit: (data: MedicWorkloadFilterForm) => void;
    onSubmitError: (errors: FieldErrors<MedicWorkloadFilterForm>) => void;
}

export const MedicWorkloadFilterBar: React.FC<MedicWorkloadFilterBarProps> = ({
    methods,
    onSubmit,
    onSubmitError
}) => {
    const period = methods.watch('period');
    const date = methods.watch('date');
    const interval = methods.watch('interval');

    const isFormValid = period && date && interval && methods.watch('medics')?.length > 0;

    return (
        <Box component="form" noValidate>
            <Box sx={{ display: 'flex', flexDirection: { xs: 'column', md: 'row' }, gap: 2, mb: 2, mt: 1, alignItems: { xs: 'stretch', md: 'flex-start' } }}>
                <Box sx={{ flex: 1, minWidth: 0, overflow: 'visible' }}>
                    <PeriodFormControl
                        name="period"
                    />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0, overflow: 'visible' }}>
                    {period === AnalyticsPeriod.Day ? (
                        <DatePickerFormControl
                            name="date"
                            label="Дата"
                            required
                            style={{ width: '100%' }}
                            disabled={!period}
                        />
                    ) : period === AnalyticsPeriod.Month ? (
                        <DatePickerFormControl
                            name="date"
                            label="Дата"
                            required
                            style={{ width: '100%' }}
                            disabled={!period}
                            views={['month', 'year']}
                            onChangeCustom={(newValue) => {
                                // Store the month/year selection (first day of month)
                                return newValue?.isValid() ? newValue.startOf('month') : null;
                            }}
                        />
                    ) : (
                        <DatePickerFormControl
                            name="date"
                            label="Дата"
                            required
                            style={{ width: '100%' }}
                            disabled={true}
                        />
                    )}
                </Box>
                <Box sx={{ flex: 1, minWidth: 0, overflow: 'visible' }}>
                    <IntervalFormControl
                        name="interval"
                        periodName="period"
                        disabled={!period}
                    />
                </Box>
                <Box sx={{ flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', overflow: 'visible' }}>
                    <MedicsAutocompleteFormControl
                        name="medics"
                        label="Медицинский работник"
                        required
                        style={{ width: '100%', marginTop: 0 }}
                        disabled={!period}
                    />
                </Box>
            </Box>
            <Box display="flex" justifyContent="flex-end" gap={2}>
                <TmFullButton
                    sx={{ minWidth: 180 }}
                    onClick={methods.handleSubmit(onSubmit, onSubmitError)}
                    disabled={!isFormValid}
                >
                    Сформировать отчет
                </TmFullButton>
            </Box>
        </Box>
    );
};

